/**
 * Whether the sidebar is hidden on a wide screen (its button, or the one that brings it back), kept in this browser:
 * hidden, the page takes the window's whole width.
 */

import { signal } from "@preact/signals";
import { store, stored } from "./storage.ts";

const KEY = "revisa.nav.hidden";

export const navHidden = signal(stored(KEY) === "1");

export function setNavHidden(on: boolean): void {
  navHidden.value = on;
  store(KEY, on ? "1" : null);
}
